import { BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue } from '../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { PlatformStorage_instance2f13b75vguf60 as PlatformStorage_instance } from '../PlatformStorage.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../navigation/urls.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PersistentPropertyClass;
function PersistentProperty() {
  if (PersistentPropertyClass === VOID) {
    class $ extends BaseReactiveValue() {
      static qd8(key, defaultValue, serializer) {
        var $this = this.xao(defaultValue);
        $this.od8_1 = key;
        $this.pd8_1 = serializer;
        var stored = PlatformStorage_instance.gi($this.od8_1);
        if (!(stored == null))
          try {
            protoOf(BaseReactiveValue()).oam.call($this, get_DefaultJson().w27($this.pd8_1, stored));
          } catch ($p) {
            if ($p instanceof Exception()) {
              var e = $p;
            } else {
              throw $p;
            }
          }
        return $this;
      }
      oam(value) {
        PlatformStorage_instance.rd8(this.od8_1, get_DefaultJson().v27(this.pd8_1, value));
        super.oam(value);
      }
      f2() {
        return super.f2();
      }
      iah(value, $completion) {
        this.oam(value);
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    initMetadataForClass($, 'PersistentProperty', VOID, VOID, [MutableReactiveValue(), BaseReactiveValue()], [1]);
    PersistentPropertyClass = $;
  }
  return PersistentPropertyClass;
}
//region block: exports
export {
  PersistentProperty as PersistentProperty2s7ex88zm8bn9,
};
//endregion

//# sourceMappingURL=PersistentProperty.mjs.map
